<template>
  <div class="border-b border-gray-300 sticky top-0 z-10 bg-white px-2 py-1">
    <div class="flex justify-between items-center w-full gap-2">
      <!-- Dropdown Tab Selection for Mobile -->
      <div class="flex-grow max-w-[65%]">
        <v-select
          :items="filteredTabs"
          item-text="label"
          item-value="key"
          v-model="localActiveTab"
          @change="onTabChange"
          outlined
          dense
          hide-details
          prepend-inner-icon="mdi-format-list-bulleted"
          class="mobile-tab-select"
        ></v-select>
      </div>

      <!-- Action Buttons Slot -->
      <div class="flex-shrink-0">
        <slot name="tab-buttons" :activeTab="localActiveTab"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActitiveTabcomponent_mobile',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    },
    insideDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localActiveTab: this.activeTab
    }
  },
  watch: {
    activeTab(newVal) {
      this.localActiveTab = newVal
    }
  },
  computed: {
    filteredTabs() {
      const excludedKeys = ['Salarytemplate', 'leave', 'holiday']
      return this.tabs.filter((tab) => !excludedKeys.includes(tab.key))
    }
  },
  methods: {
    onTabChange(val) {
      this.$emit('tab-changed', val)
    }
  }
}
</script>

<style scoped>
.mobile-tab-select >>> .v-input__control > .v-input__slot {
  min-height: 38px !important;
  font-size: 13px !important;
}
</style>
